import { useEffect, useState } from "react";

import { useNotificationContext } from "cerulean";
import { useObjectMemo } from "byzantine";
import ApiHttp from "byzantine/src/ApiHttp";
import { useLocalization } from "@fluent/react";

import type { LinkedProfile } from "./sidebar.profile.switcher.types";

export const useGetLinkedProfiles = (isEnabled: boolean) => {
  const [isFetching, setIsFetching] = useState<boolean>(false);
  const [linkedProfiles, setLinkedProfiles] = useState<LinkedProfile[]>([]);
  const { sendNotification } = useNotificationContext();
  const { l10n } = useLocalization();

  useEffect(() => {
    const fetchProfiles = async () => {
      setIsFetching(true);
      try {
        const response = await ApiHttp.fetch("/linked_profiles", {
          method: "GET",
          endpointIsUrl: true,
        });
        if (response?.linked_profiles) {
          const allLinkedProfiles = response?.linked_profiles;
          setLinkedProfiles(allLinkedProfiles);
        }
      } catch {
        sendNotification({
          type: "negative",
          text: l10n.getString(
            "loading-linked-profiles-error",
            null,
            "There was an error retrieving your linked profiles, please try again later."
          ),
        });
      }
      setIsFetching(false);
    };
    if (isEnabled) {
      fetchProfiles();
    }
  }, [isEnabled, sendNotification, l10n]);

  return useObjectMemo({ isFetching, linkedProfiles });
};
